import { render, staticRenderFns } from "./AddressDropdown.vue?vue&type=template&id=5bcb295e&scoped=true&"
import script from "./AddressDropdown.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./AddressDropdown.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./AddressDropdown.vue?vue&type=style&index=0&id=5bcb295e&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcb295e",
  null
  
)

export default component.exports